import { useEffect } from "react";

import { useGetUserDetailsQuery } from "@store/services/user";
import { useTranslation } from "react-i18next";
import { useSearchParams } from "react-router-dom";
import { enqueueSnackbar } from "notistack";

import { applicationUrl } from "@constants";

const queryParameters = {
  newEmail: "newEmail",
  changeEmailToken: "changeEmailToken",
};

const SharedEmailCheck = () => {
  const { t } = useTranslation();
  const [searchParameter, setSearchParameters] = useSearchParams();
  const { data: userDetailsData } = useGetUserDetailsQuery();

  useEffect(() => {
    if (userDetailsData?.authenticated && searchParameter.has(queryParameters.newEmail)) {
      const newEmail = searchParameter.get(queryParameters.newEmail);
      const changeEmailToken = searchParameter.get(queryParameters.changeEmailToken);
      const updateMail = async () => {
        try {
          const response = await fetch(`${applicationUrl}/user/change-email/${changeEmailToken}?new_email=${newEmail}`);
          if (!response.ok) {
            enqueueSnackbar(t("global.errors.genericError"), { variant: "error" });
            return;
          }
          enqueueSnackbar(t("sharedEmail.success"), { variant: "success" });
        } catch {
          enqueueSnackbar(t("global.errors.genericError"), { variant: "error" });
        } finally {
          const updatedParameters = new URLSearchParams(searchParameter.toString());
          updatedParameters.delete(queryParameters.newEmail);
          updatedParameters.delete(queryParameters.changeEmailToken);
          setSearchParameters(updatedParameters);
        }
      };
      updateMail();
    }
  }, [userDetailsData, searchParameter, setSearchParameters]);

  return null;
};

export default SharedEmailCheck;
